<script setup lang="ts">
import { RouterView } from "vue-router"
import ToastHost from "@/components/notifications/ToastHost.vue"
import WelcomeModal from "@/components/modals/WelcomeModal.vue"
import AppTour from "@/components/onboarding/AppTour.vue"
import { config, Feature } from "@/AppConfig"
import PrivacySettings from "@/components/privacy/PrivacySettings.vue"
import { usePrivacyStore } from "@/stores/privacyStore"

const privacy = usePrivacyStore()
</script>

<template>
	<RouterView />
	<ToastHost />
	<PrivacySettings />
	<WelcomeModal v-if="privacy.hasChoice && !privacy.isSettingsOpen" />
	<AppTour v-if="config.ui.has(Feature.AppTour)" />
</template>
